import {ICON_TYPES} from '../constants';

export const Calendar = (): JSX.Element => {
  return (
    <>
      <svg
        width='14'
        height='16'
        viewBox='0 0 14 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M11 1.33301V2.66634M3 1.33301V2.66634'
          stroke='#2D2D2D'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M6.9918 8.66602H6.99778M6.9918 11.3327H6.99778M9.65548 8.66602H9.66146M4.32812 8.66602H4.33411M4.32812 11.3327H4.33411'
          stroke='#2D2D2D'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M1.32812 5.33301H12.6615'
          stroke='#2D2D2D'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M0.664062 8.16216C0.664062 5.25729 0.664062 3.80486 1.49881 2.90243C2.33355 2 3.67706 2 6.36406 2H7.63073C10.3177 2 11.6612 2 12.496 2.90243C13.3307 3.80486 13.3307 5.25729 13.3307 8.16216V8.5045C13.3307 11.4094 13.3307 12.8618 12.496 13.7642C11.6612 14.6667 10.3177 14.6667 7.63073 14.6667H6.36406C3.67706 14.6667 2.33355 14.6667 1.49881 13.7642C0.664062 12.8618 0.664062 11.4094 0.664062 8.5045V8.16216Z'
          stroke='#2D2D2D'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M1 5.33301H13'
          stroke='#2D2D2D'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </>
  );
};

Calendar.iconType = ICON_TYPES.CALENDAR;
